module.exports = {
      id: "longform-usage",
      viewBox: "0 0 12.6 15.258",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#longform",
      toString: function () {
        return this.url;
      }
    }